let sticky_header = (function( $ ) {

	let $header;

	let _init = function() {
		$header = $( '#header' );

		_toggle_fixed_class();
		$( window ).on( 'scroll', _toggle_fixed_class );
	};

	let _toggle_fixed_class = function() {
		let $scroll = $( window ).scrollTop();

		if ( $scroll > 0 && !$header.hasClass( 'fixed' ) ) {
			$header.addClass( 'fixed' );
		} else if ( 0 === $scroll && $header.hasClass( 'fixed' ) ) {
			$header.removeClass( 'fixed' );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = sticky_header;